import React from "react";
import FAQItem from "./FAQItem";

const FAQ: React.FC = () => {

    return (
        <>
            <FAQItem title="Welche Versicherung braucht man für einen Hund?" 
                text={<React.Fragment>
                    Zu den wichtigsten Versicherungen für Hundehalter*innen gehört auf jeden Fall eine Hundehaftpflicht. In einigen Bundesländern ist sie sogar Pflicht.
                    <br />Die Hundehaftpflichtversicherung ersetzt Schäden, die der eigene Hund verursacht und wehrt unberechtigte Schadenforderungen ab.
                </React.Fragment>} />
            <FAQItem title="Warum brauche ich eine Hundehaftpflicht?" 
                text={<React.Fragment>
                    Als Hundehalter*in haften Sie in unbegrenzter Höhe für Schäden, die das eigene Tier verursacht. Dazu gehören Personen-, Sach- und Vermögensschäden. 
                    <br />Bei solchen Schäden hilft eine Hundehaftpflichtversicherung. Diese ist in einigen Bundesländern Pflicht.
                </React.Fragment>} />
            <FAQItem title="Wo ist die Hundehaftpflichtversicherung Pflicht?" 
                text={<React.Fragment>
                    Es gibt keine bundesweit einheitliche Regelung zum Thema Hundehalterhaftpflicht.
                    <br />In folgenden Bundesländern müssen Hundehalter*innen eine Haftpflicht zwingend abschließen: Berlin, Hamburg, Niedersachsen, Schleswig-Holstein, Thüringen, Sachsen-Anhalt.
                    <br />Bei als gefährlich eingestufte Rassen gilt die Verpflichtung zum Abschluss z.B. in Baden-Württemberg, Brandenburg, Bremen, Hessen oder Nordrhein-Westfalen. 
                    <br />Am besten informiert man sich bei der zuständigen Behörde oder schließt zur Sicherheit direkt eine Hundehaftpflicht ab.
                </React.Fragment>} />
            <FAQItem title="Wie hoch sollte die Versicherungssumme bei der Hundehaftpflicht sein?" 
                text={<React.Fragment>
                    Da Sie als Halter*in in unbegrenzter Höhe für Schäden durch Ihren Hund haften, sollte die Versicherungssumme nicht zu niedrig angesetzt werden. 
                    <br />Mit der Versicherungssumme von 20 Mio. Euro bei unserer Hunde-Haftpflicht+ sind Sie auf jeden Fall auf der sicheren Seite.
                </React.Fragment>} />
            <FAQItem title="Was ist in der Hundehaftpflicht versichert? Was ist wichtig?" 
                text={<React.Fragment>
                Folgende Schäden sind über die Hundehaftpflicht abgedeckt:<br />
                &bull; Personenschäden<br />
                &bull; Sachschäden<br />
                &bull; Vermögensschäden<br />
                Außerdem wehrt die Hundehaftpflicht unbegründete Forderungen ab.</React.Fragment>} />
            <FAQItem title="Wie kann ich mich in der Hundehalter-Haftpflichtversicherung noch besser absichern?" 
                text={<React.Fragment>
                    Der Hundeschutzbrief von Rheinland sichert Ihnen wichtige und hilfreiche Zusatzleistungen. 
                    <br />Zum Beispiel eine Notbetreuung für den Vierbeiner, wenn Sie krank sind. Oder einen Notfalltransport bei einem Verdacht auf Giftköder. 
                    Oder eine Beratung zu Einreisebestimmungen und Impflichten für den nächsten Urlaub.
                </React.Fragment>} />
            <FAQItem title="Gibt es noch andere Tierhalter-Haftpflichtversicherungen?" 
                text={<React.Fragment>
                    Kleine Haustiere wie Katzen, Kaninchen oder Wellensittiche sind über die private Haftpflichtversicherung abgesichert. 
                    <br />Für Hunde und Pferde hingegen brauchen Sie eine gesonderte Haftpflichtversicherung. 
                    Neben der Hundehalterhaftpflicht können Sie bei der RheinLand auch die Pferdehaftpflicht für Pferde, Kleinpferde, Ponys und Esel abschließen.
                </React.Fragment>} />
            <FAQItem title="Gibt es bei der Hundehaftpflicht eine Selbstbeteiligung?" 
                text={<React.Fragment>
                    Im Plus-Paket gibt es keine Selbstbeteiligungen. Sie zahlen also keinen eigenen Anteil im Schadenfall.
                </React.Fragment>} />
            <FAQItem title="Gibt es einen Rabatt für 2 Hunde?" 
                text={<React.Fragment>
                    Ab dem 2. Hund wird’s günstiger und Sie zahlen weniger pro Tier.
                </React.Fragment>} />
            <FAQItem title="Wann zahlt die Hundehaftpflicht nicht?" 
                text={<React.Fragment>
                    Über die Hundehaftpflicht sind Schäden bei Dritten abgedeckt. 
                    Die Hundehaftpflicht zahlt nicht für Schäden, die der Hund Ihnen selbst, anderen Personen im Haushalt oder Ihrem Eigentum zufügt.
                </React.Fragment>} />
            <FAQItem title="Wer ist die RheinLand Versicherungs AG?" 
                text={<React.Fragment>
                    Die RheinLand Versicherungs AG ist ein Versicherungsunternehmen aus Neuss. Seit über 130 Jahren stehen wir für Kontinuität und Familiengefühl. 
                    <br />Als eine der wenigen noch privat geführten Versicherungsgesellschaften in Deutschland 
                    begleiten wir Sie durch alle Lebenslagen und stehen Ihnen als erfahrener und routinierter Partner in allen Versicherungsfragen zur Seite.
                </React.Fragment>} />
        </>
    );
}

export default FAQ;